export type Pillar = {
  id: string;
  title: string;
  body: string;
  href: string;
  cta: string;
};

export type MatchDimension = {
  name: string;
  percent: number;
  animationDelaySeconds: number;
};

export type DesignerFileCard = {
  id: string;
  label: string;
  location: string;
  imageUrl: string;
};

export type PerspectiveCard = {
  id: string;
  title: string;
  href: string;
  bgClassName: string;
};

export const PRESS_LOGOS = [
  "BUSINESS OF HOME",
  "StyleBlueprint",
  "VERANDA",
  "DESIGNERS TODAY",
];

export const PILLARS: Pillar[] = [
  {
    id: "01",
    title: "The HDG Authorized Seal",
    body: "Every interior designer in our network has passed rigorous HDG vetting — portfolio review, client references, and 3+ years of full-time residential design experience. The Seal is your guarantee of excellence.",
    href: "/about-us#the-seal",
    cta: "About the Seal",
  },
  {
    id: "02",
    title: "Smart-Guild Matching™",
    body: "Our patent-pending algorithm matches homeowners with the best interior designers across 40+ variables — personality, lifestyle, project scope, and budget — so your first introduction is already a fit.",
    href: "/how-matching-works",
    cta: "How Matching Works",
  },
  {
    id: "03",
    title: "Designer Files",
    body: "Browse real project portfolios — full before and afters, room transformations, and design case studies from HDG authorized designers — so you can hire with total confidence before your first consultation.",
    href: "/designer-files",
    cta: "Browse Projects",
  },
];

export const MATCH_DIMENSIONS: MatchDimension[] = [
  { name: "Personality Alignment", percent: 94, animationDelaySeconds: 0 },
  { name: "Preference Compatibility", percent: 88, animationDelaySeconds: 0.25 },
  { name: "Project Fit", percent: 97, animationDelaySeconds: 0.5 },
];

export const DESIGNER_FILE_CARDS: DesignerFileCard[] = [
  {
    id: "designer_d8655236616",
    label: "Designer_d8655236616",
    location: "Atlanta, GA · Full-Service Interior Design",
    imageUrl:
      "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/iatk4RAPtMOPMhPoQP7M/media/67ef20e39044f704a5b1cb90.png",
  },
  {
    id: "designer_d8b94469558",
    label: "Designer_d8b94469558",
    location: "Atlanta, GA · Interior Decorating & Styling",
    imageUrl:
      "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://storage.googleapis.com/funnel-ai-production/image-generation/iatk4RAPtMOPMhPoQP7M/vetted-community-ReuWg17wox.png",
  },
  {
    id: "designer_d9cc9893128",
    label: "Designer_d9cc9893128",
    location: "Atlanta, GA · New Construction Design",
    imageUrl:
      "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/iatk4RAPtMOPMhPoQP7M/media/67ef20e39044f704a5b1cb90.png",
  },
  {
    id: "designer_d7a12345678",
    label: "Designer_d7a12345678",
    location: "Atlanta, GA · Whole-Home Renovation",
    imageUrl:
      "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://storage.googleapis.com/funnel-ai-production/image-generation/iatk4RAPtMOPMhPoQP7M/vetted-community-ReuWg17wox.png",
  },
  {
    id: "designer_d7b98765432",
    label: "Designer_d7b98765432",
    location: "Atlanta, GA · Room-by-Room Design",
    imageUrl:
      "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/iatk4RAPtMOPMhPoQP7M/media/67ef20e39044f704a5b1cb90.png",
  },
  {
    id: "designer_d6c55544433",
    label: "Designer_d6c55544433",
    location: "Atlanta, GA · Full-Service Interior Design",
    imageUrl:
      "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://storage.googleapis.com/funnel-ai-production/image-generation/iatk4RAPtMOPMhPoQP7M/vetted-community-ReuWg17wox.png",
  },
  {
    id: "designer_d5d11223344",
    label: "Designer_d5d11223344",
    location: "Atlanta, GA · Transitional & Classic",
    imageUrl:
      "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/iatk4RAPtMOPMhPoQP7M/media/67ef20e39044f704a5b1cb90.png",
  },
  {
    id: "designer_d4e99887766",
    label: "Designer_d4e99887766",
    location: "Atlanta, GA · Contemporary Design",
    imageUrl:
      "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://storage.googleapis.com/funnel-ai-production/image-generation/iatk4RAPtMOPMhPoQP7M/vetted-community-ReuWg17wox.png",
  },
  {
    id: "designer_d3f66778899",
    label: "Designer_d3f66778899",
    location: "Atlanta, GA · Luxury Residential",
    imageUrl:
      "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/iatk4RAPtMOPMhPoQP7M/media/67ef20e39044f704a5b1cb90.png",
  },
];

export const PERSPECTIVE_CARDS: PerspectiveCard[] = [
  {
    id: "relationship-matters",
    title: "Why the Relationship Matters",
    href: "/homeowners#why-join",
    bgClassName: "vc-bg1",
  },
  {
    id: "why-hdg",
    title: "Why Use Home Design Guild",
    href: "/how-matching-works",
    bgClassName: "vc-bg2",
  },
  {
    id: "hdg-seal",
    title: "The HDG Authorized Seal",
    href: "/about-us#the-seal",
    bgClassName: "vc-bg3",
  },
  {
    id: "personality-match",
    title: "The Personality Match Explained",
    href: "/how-matching-works",
    bgClassName: "vc-bg1",
  },
  {
    id: "designer-files",
    title: "Behind the Designer Files",
    href: "/designer-files",
    bgClassName: "vc-bg2",
  },
  {
    id: "first-match",
    title: "A Homeowner's First Match",
    href: "/homeowners#why-join",
    bgClassName: "vc-bg3",
  },
  {
    id: "vetting",
    title: "How We Vet Every Designer",
    href: "/about-us",
    bgClassName: "vc-bg1",
  },
  {
    id: "smart-guild",
    title: "Smart-Guild Matching™ Deep Dive",
    href: "/how-matching-works",
    bgClassName: "vc-bg2",
  },
  {
    id: "dream-home",
    title: "From Introduction to Dream Home",
    href: "/homeowners#why-join",
    bgClassName: "vc-bg3",
  },
];
